import * as React from "react";
const SvgDots = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 236,
	height: 106,
	viewBox: "0 0 236 106",
	fill: "none",
	...props
}, /* @__PURE__ */ React.createElement("rect", {
	x: 234,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 208,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 182,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 156,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 130,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 234,
	y: 26,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 208,
	y: 26,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 182,
	y: 26,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 156,
	y: 26,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 130,
	y: 26,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 234,
	y: 52,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 208,
	y: 52,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 182,
	y: 52,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 156,
	y: 52,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 130,
	y: 52,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 234,
	y: 78,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 208,
	y: 78,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 182,
	y: 78,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 156,
	y: 78,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 130,
	y: 78,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 234,
	y: 104,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 208,
	y: 104,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 182,
	y: 104,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 156,
	y: 104,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 130,
	y: 104,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 104,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 78,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 52,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 26,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 104,
	y: 26,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 78,
	y: 26,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 52,
	y: 26,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 26,
	y: 26,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	y: 26,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 104,
	y: 52,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 78,
	y: 52,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 52,
	y: 52,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 26,
	y: 52,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	y: 52,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 104,
	y: 78,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 78,
	y: 78,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 52,
	y: 78,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 26,
	y: 78,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	y: 78,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 104,
	y: 104,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 78,
	y: 104,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 52,
	y: 104,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 26,
	y: 104,
	width: 2,
	height: 2,
	fill: "#4D5258"
}), /* @__PURE__ */ React.createElement("rect", {
	y: 104,
	width: 2,
	height: 2,
	fill: "#4D5258"
}));
export default SvgDots;
